<app-component-html-template [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="packagingAid" [form]="form" [componentSubtypes]="componentSubtypes"
  [callerId]="callerId" [isPreview]="isPreview" [isTracked]="isTracked" [isFormLocked]="isFormLocked"
  [historyVersions]="historyVersions" [spinnerActive]="spinnerActive" [canEditForm]="canEditForm"
  [isUserValidator]="isUserValidator" [isEditPermitted]="isEditPermitted" [imageSource]="imageSource"
  [componentTypeSelectionLabel]="'component.fields.ofPackagingAid' | transloco"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  [changedMaterialsInfo]="changedMaterialsInfo" (submitted)="onComponentSubmit($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (createDataExchangeRequestClicked)="createDataExchangeRequest($event)"
  (historicVersionClicked)="loadHistoryVersions(packagingAid.id)" (historicVersionChanged)="onHistoryVersionChange($event)" (versionRenamed)="changePackAidVersionName($event)"
  (materialChangeHandled)="handleMaterialChange($event)">

  <h1 header>{{ 'component.packagingAid' | transloco }}</h1>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="packagingAid.images" (filesEdited)="onFilesEdited()">
    </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="packagingAid.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="packagingAid.documents" (filesEdited)="onFilesEdited()">
    </app-pdf-upload>
  </div>

</app-component-html-template>
